import { useTranslation } from 'react-i18next';

import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import PropTypes from 'prop-types';
import { formatDatetime } from 'utils/func';

export default function ViewAdjustmentHistory({
  data,
  visible,
  setVisible,
  reverse,
  width,
  isLoading,
}) {
  const { t } = useTranslation();

  const formatCreatedAt = (value) => {
    const datetime = formatDatetime(value.createdAt, 'DD/MM/YYYY HH:mm:ss');
    return <small className="text-color-secondary">{datetime}</small>;
  };

  const formatComment = (value) => (
    <span style={{ whiteSpace: 'pre-wrap' }} className="text-color-secondary">
      {value.comment}
    </span>
  );

  const formatReply = (value) => (
    <div className="flex justify-content-between align-items-center gap-2">
      <span style={{ whiteSpace: 'pre-wrap' }} className="text-color-secondary">
        {value.reply}
      </span>
    </div>
  );

  return (
    <Dialog
      header={<p className="text-blue-500">{t('projectAdjustment.viewHistory.title')}</p>}
      visible={visible}
      position="center"
      style={{ width }}
      onHide={() => setVisible(false)}
      draggable={false}
    >
      <DataTable
        value={data}
        className="p-datatable-gridlines header-table"
        scrollable
        scrollHeight="450px"
        showGridlines
        emptyMessage={t('projectAdjustment.viewHistory.empty')}
        isLoading={isLoading}
      >
        <Column
          header={t('proposal.history.no')}
          // eslint-disable-next-line react/no-unstable-nested-components
          body={(_, { rowIndex }) => <span>{reverse ? data.length - rowIndex : rowIndex + 1}</span>}
          style={{ width: '50px', textAlign: 'center' }}
        />
        <Column
          field="createdBy.fullname"
          header={t('projectAdjustment.viewHistory.createdBy')}
          style={{ minWidth: '10rem', textAlign: 'left' }}
        />
        <Column
          field="comment"
          header={t('projectAdjustment.viewHistory.comment')}
          style={{ minWidth: '16rem', textAlign: 'left' }}
          body={formatComment}
        />
        <Column
          field="reply"
          header={t('projectAdjustment.viewHistory.reply')}
          style={{ minWidth: '16rem', textAlign: 'left' }}
          body={formatReply}
        />
        <Column
          field="createdAt"
          header={t('projectAdjustment.viewHistory.createdAt')}
          body={formatCreatedAt}
          style={{ minWidth: '5rem', textAlign: 'left' }}
        />
      </DataTable>
    </Dialog>
  );
}

ViewAdjustmentHistory.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.array.isRequired,
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  reverse: PropTypes.bool,
  width: PropTypes.string,
  isLoading: PropTypes.bool,
};

ViewAdjustmentHistory.defaultProps = {
  reverse: false,
  width: '900px',
  isLoading: false,
};
